// import React, { useContext } from 'react';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet-async';
// import { motion } from 'framer-motion';
// import { AppContext } from '../App';

// const Services = () => {
//   const { services } = useContext(AppContext);
//   const activeServices = services.filter(s => s.isActive);

//   const categories = [
//     { id: 'all', name: 'All Services', icon: '📋' },
//     { id: 'mutual-fund', name: 'Mutual Funds', icon: '📈' },
//     { id: 'insurance', name: 'Insurance', icon: '🛡️' },
//     { id: 'loan', name: 'Loans', icon: '🏠' },
//     { id: 'financial-planning', name: 'Financial Planning', icon: '🎯' },
//   ];

//   const [selectedCategory, setSelectedCategory] = React.useState('all');

//   const filteredServices = selectedCategory === 'all'
//     ? activeServices
//     : activeServices.filter(s => s.type === selectedCategory);

//   return (
//     <>
//       <Helmet>
//         <title>Our Services - Mutual Funds, Insurance, Loans & Financial Planning | Wisdom Consultancy</title>
//         <meta name="description" content="Explore our comprehensive financial services including mutual funds, insurance, home loans, retirement planning, and wealth management solutions." />
//       </Helmet>

//       {/* Hero Section */}
//       <div className="bg-gradient-to-r from-primary to-secondary py-16">
//         <div className="container-custom text-center text-white">
//           <motion.h1
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="text-4xl md:text-5xl font-bold mb-4"
//           >
//             Our Financial Services
//           </motion.h1>
//           <motion.p
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.1 }}
//             className="text-xl opacity-90 max-w-3xl mx-auto"
//           >
//             Comprehensive solutions for every financial need
//           </motion.p>
//         </div>
//       </div>

//       {/* Category Filter */}
//       <div className="container-custom py-8">
//         <div className="flex flex-wrap gap-3 justify-center">
//           {categories.map(cat => (
//             <button
//               key={cat.id}
//               onClick={() => setSelectedCategory(cat.id)}
//               className={`px-5 py-2 rounded-full font-semibold transition-all duration-300 flex items-center gap-2 ${selectedCategory === cat.id
//                   ? 'bg-gradient-to-r from-primary to-secondary text-white shadow-lg'
//                   : 'bg-white text-gray-700 hover:shadow-md border border-gray-200'
//                 }`}
//             >
//               <span>{cat.icon}</span>
//               {cat.name}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Services Grid */}
//       <section className="py-12 bg-gray-50">
//         <div className="container-custom">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {filteredServices.map((service, index) => (
//               <motion.div
//                 key={service.id}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.1 }}
//                 className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 group"
//               >
//                 <div className="p-6">
//                   <div className="text-6xl mb-4">{service.icon}</div>
//                   <h3 className="text-xl font-bold text-primary mb-2">{service.title}</h3>
//                   <p className="text-gray-600 mb-4">{service.description}</p>

//                   {service.features && service.features.length > 0 && (
//                     <div className="mb-4">
//                       <p className="font-semibold text-sm text-gray-700 mb-2">Key Features:</p>
//                       <div className="flex flex-wrap gap-1">
//                         {service.features.slice(0, 3).map((f, i) => (
//                           <span key={i} className="text-xs bg-blue-50 text-blue-700 px-2 py-1 rounded">✓ {f}</span>
//                         ))}
//                       </div>
//                     </div>
//                   )}

//                   <Link
//                     to="/contact"
//                     className="inline-flex items-center gap-2 text-accent font-semibold group-hover:gap-3 transition-all"
//                   >
//                     Enquire Now →
//                   </Link>
//                 </div>
//               </motion.div>
//             ))}
//           </div>

//           {filteredServices.length === 0 && (
//             <div className="text-center py-12">
//               <p className="text-gray-500">No services found in this category.</p>
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Consultation CTA */}
//       <section className="py-16 bg-gradient-to-r from-primary to-secondary text-white">
//         <div className="container-custom text-center">
//           <h2 className="text-3xl font-bold mb-4">Need Personalized Financial Advice?</h2>
//           <p className="text-xl mb-6 opacity-90">Our experts are here to help you make informed decisions</p>
//           <Link to="/contact" className="bg-accent px-8 py-3 rounded-lg font-semibold hover:bg-opacity-90 transition-all inline-block">
//             Schedule Free Consultation
//           </Link>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Services;

// import React, { useContext, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet-async';
// import { motion } from 'framer-motion';
// import { AppContext } from '../App';

// import {
//   FaArrowRight,
//   FaChartLine,
//   FaShieldAlt,
//   FaHome,
//   FaWallet,
//   FaHeartbeat,
//   FaCar,
// } from 'react-icons/fa';

// const Services = () => {
//   const { services } = useContext(AppContext);

//   const activeServices = services.filter((s) => s.isActive);

//   const categories = [
//     { id: 'all', name: 'All Services', icon: '📋' },
//     { id: 'mutual-fund', name: 'Mutual Funds', icon: '📈' },
//     { id: 'insurance', name: 'Insurance', icon: '🛡️' },
//     { id: 'loan', name: 'Loans', icon: '🏠' },
//   ];

//   const [selectedCategory, setSelectedCategory] = useState('all');

//   const filteredServices =
//     selectedCategory === 'all'
//       ? activeServices
//       : activeServices.filter((s) => s.type === selectedCategory);

//   return (
//     <>
//       <Helmet>
//         <title>
//           Our Services - Mutual Funds, Insurance & Financial Planning |
//           Wisdom Consultancy
//         </title>

//         <meta
//           name="description"
//           content="Professional financial solutions focused on wealth creation, protection, and long-term financial success."
//         />
//       </Helmet>

//       {/* MAIN SECTION */}
//       <section className="relative overflow-hidden bg-[#f6f7f8]">
//         {/* GRID BACKGROUND */}
//         <div
//           className="absolute inset-0 opacity-40"
//           style={{
//             backgroundImage: `
//               linear-gradient(to right, #d8d8d8 1px, transparent 1px),
//               linear-gradient(to bottom, #d8d8d8 1px, transparent 1px)
//             `,
//             backgroundSize: '40px 40px',
//           }}
//         />

//         <div className="container-custom relative z-10 py-20">
//           {/* HERO */}
//           <div className="grid lg:grid-cols-2 gap-14 items-center">
//             {/* LEFT CONTENT */}
//             <motion.div
//               initial={{ opacity: 0, x: -40 }}
//               whileInView={{ opacity: 1, x: 0 }}
//             >
//               {/* BADGE */}
//               <div className="inline-flex items-center gap-3 bg-white shadow-md px-5 py-3 rounded-full mb-8">
//                 <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
//                   <FaChartLine />
//                 </div>

//                 <span className="font-semibold text-[#0b1c39]">
//                   Financial Services
//                 </span>
//               </div>

//               {/* HEADING */}
//               <h1 className="text-5xl md:text-7xl font-extrabold leading-tight text-[#222]">
//                 Financial Planning
//                 <br />
//                 That Works{' '}
//                 <span className="text-[#67bf73]">for You</span>
//               </h1>

//               {/* SUB HEADING */}
//               <h3 className="text-2xl md:text-3xl font-bold text-[#2e56b8] mt-6">
//                 Secure. Grow. Prosper.
//               </h3>

//               {/* DESCRIPTION */}
//               <p className="mt-6 text-lg md:text-xl text-gray-600 leading-9 max-w-2xl">
//                 Professional financial solutions focused on wealth creation,
//                 protection, and long-term financial success.
//               </p>

//               {/* BUTTON */}
//               <div className="mt-10">
//                 <Link
//                   to="/contact"
//                   className="inline-flex items-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
//                 >
//                   Book Free Consultation
//                   <FaArrowRight />
//                 </Link>
//               </div>
//             </motion.div>

//             {/* RIGHT IMAGE */}
//             <motion.div
//               initial={{ opacity: 0, x: 40 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               className="relative"
//             >
//               {/* MAIN IMAGE */}
//               <div className="rounded-[35px] overflow-hidden shadow-2xl">
//                 <img
//                   src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=1200&auto=format&fit=crop"
//                   alt="Financial Planning"
//                   className="w-full h-[500px] object-cover"
//                 />
//               </div>

//               {/* FLOATING CARD */}
//               <div className="absolute -bottom-10 -left-8 bg-gradient-to-br from-[#1f4ba8] to-[#255bcb] text-white rounded-[28px] p-8 w-[280px] shadow-2xl">
//                 <div className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center mb-6">
//                   <FaWallet size={22} />
//                 </div>

//                 <h3 className="text-4xl font-bold mb-2">
//                   Wealth Growth
//                 </h3>

//                 <p className="opacity-80 text-sm mb-8">
//                   Smart Financial Planning
//                 </p>

//                 <div className="h-[80px] relative overflow-hidden">
//                   <svg
//                     viewBox="0 0 300 100"
//                     className="absolute inset-0 w-full h-full"
//                     fill="none"
//                   >
//                     <path
//                       d="M0 60 C40 20, 80 90, 120 50 S200 10, 300 70"
//                       stroke="rgba(255,255,255,0.4)"
//                       strokeWidth="3"
//                     />
//                   </svg>
//                 </div>
//               </div>

//               {/* CIRCLE BADGE */}
//               <div className="absolute top-1/2 -left-10 bg-white w-32 h-32 rounded-full shadow-xl flex items-center justify-center border-8 border-[#f6f7f8]">
//                 <div className="text-center">
//                   <p className="text-sm text-[#2e56b8] font-bold">
//                     Secure
//                   </p>

//                   <p className="text-sm text-[#67bf73] font-bold">
//                     Future
//                   </p>
//                 </div>
//               </div>
//             </motion.div>
//           </div>

//           {/* CATEGORY FILTER */}
//           <div className="mt-24 flex flex-wrap justify-center gap-4">
//             {categories.map((cat) => (
//               <button
//                 key={cat.id}
//                 onClick={() => setSelectedCategory(cat.id)}
//                 className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 border ${
//                   selectedCategory === cat.id
//                     ? 'bg-[#2e56b8] text-white border-[#2e56b8] shadow-lg'
//                     : 'bg-white text-[#0b1c39] border-gray-200 hover:shadow-md'
//                 }`}
//               >
//                 <span className="mr-2">{cat.icon}</span>
//                 {cat.name}
//               </button>
//             ))}
//           </div>

//           {/* TITLE */}
//           <div className="mt-24 mb-14 text-center">
//             <h2 className="text-4xl md:text-5xl font-bold text-[#222]">
//               Professional{' '}
//               <span className="text-[#2e56b8]">
//                 Services
//               </span>{' '}
//               & Financial Solutions
//             </h2>

//             <p className="mt-5 text-lg text-gray-600 max-w-3xl mx-auto">
//               Customized financial strategies focused on growth,
//               protection, and future financial confidence.
//             </p>
//           </div>

//           {/* SERVICES GRID */}
//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {filteredServices.map((service, index) => (
//               <motion.div
//                 key={service.id}
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.1 }}
//                 className="group bg-white rounded-[30px] p-8 shadow-md hover:shadow-2xl transition-all duration-300 border border-transparent hover:border-[#dbe7ff]"
//               >
//                 {/* ICON */}
//                 <div className="w-20 h-20 rounded-3xl bg-[#edf3ff] flex items-center justify-center text-4xl mb-6 group-hover:scale-110 transition-transform duration-300">
//                   {service.title === 'Mutual Funds' && (
//                     <FaChartLine className="text-[#2e56b8]" />
//                   )}

//                   {service.title === 'Health Insurance' && (
//                     <FaHeartbeat className="text-[#67bf73]" />
//                   )}

//                   {service.title === 'Life Insurance' && (
//                     <FaShieldAlt className="text-[#2e56b8]" />
//                   )}

//                   {service.title === 'Home Loans' && (
//                     <FaHome className="text-[#67bf73]" />
//                   )}

//                   {service.title === 'Car & Bike Insurance' && (
//                     <FaCar className="text-[#2e56b8]" />
//                   )}
//                 </div>

//                 {/* TITLE */}
//                 <h3 className="text-2xl font-bold text-[#0b1c39] mb-4">
//                   {service.title}
//                 </h3>

//                 {/* DESCRIPTION */}
//                 <p className="text-gray-600 leading-8 mb-6">
//                   {service.description}
//                 </p>

//                 {/* FEATURES */}
//                 {service.features && service.features.length > 0 && (
//                   <div className="space-y-3 mb-8">
//                     {service.features.slice(0, 6).map((feature, i) => (
//                       <div
//                         key={i}
//                         className="flex items-start gap-3 text-gray-700 text-sm"
//                       >
//                         <div className="w-2 h-2 rounded-full bg-[#67bf73] mt-2 flex-shrink-0" />

//                         <span>{feature}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* BUTTON */}
//                 <Link
//                   to="/contact"
//                   className="inline-flex items-center gap-2 text-[#2e56b8] font-semibold hover:gap-4 transition-all duration-300"
//                 >
//                   Enquire Now
//                   <FaArrowRight />
//                 </Link>
//               </motion.div>
//             ))}
//           </div>

//           {/* EMPTY */}
//           {filteredServices.length === 0 && (
//             <div className="text-center py-20">
//               <p className="text-gray-500 text-lg">
//                 No services found in this category.
//               </p>
//             </div>
//           )}
//         </div>
//       </section>

//       {/* CTA SECTION */}
//       <section className="py-20 relative overflow-hidden bg-[#eef6f0]">
//         {/* GRID */}
//         <div
//           className="absolute inset-0 opacity-40"
//           style={{
//             backgroundImage: `
//               linear-gradient(to right, #d8d8d8 1px, transparent 1px),
//               linear-gradient(to bottom, #d8d8d8 1px, transparent 1px)
//             `,
//             backgroundSize: '40px 40px',
//           }}
//         />

//         <div className="container-custom relative z-10">
//           <div className="bg-white rounded-[40px] shadow-2xl p-10 md:p-16 text-center border border-[#e7f0eb]">
//             {/* BADGE */}
//             <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-8">
//               <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
//                 <FaChartLine />
//               </div>

//               <span className="font-semibold text-[#0b1c39]">
//                 Financial Consultation
//               </span>
//             </div>

//             {/* TITLE */}
//             <h2 className="text-4xl md:text-5xl font-bold text-[#222] leading-tight mb-6">
//               Need Expert{' '}
//               <span className="text-[#67bf73]">
//                 Financial Guidance?
//               </span>
//             </h2>

//             {/* DESCRIPTION */}
//             <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-9 mb-10">
//               Our financial experts are ready to guide you with secure,
//               tailored wealth management and investment solutions.
//             </p>

//             {/* BUTTON */}
//             <Link
//               to="/contact"
//               className="inline-flex items-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
//             >
//               Schedule Free Consultation
//               <FaArrowRight />
//             </Link>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Services;

import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { AppContext } from '../App';

import {
  FaArrowRight,
  FaChartLine,
  FaShieldAlt,
  FaHome,
  FaWallet,
  FaHeartbeat,
  FaCar,
  FaUsers,
  FaBullseye,
} from 'react-icons/fa';

const Services = () => {
  const { services } = useContext(AppContext);

  const activeServices = services.filter((s) => s.isActive);

  const categories = [
    { id: 'all', name: 'All Services', icon: '📋' },
    { id: 'mutual-fund', name: 'Mutual Funds', icon: '📈' },
    { id: 'insurance', name: 'Insurance', icon: '🛡️' },
    { id: 'loan', name: 'Loans', icon: '🏠' },
  ];

  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredServices =
    selectedCategory === 'all'
      ? activeServices
      : activeServices.filter((s) => s.type === selectedCategory);

  return (
    <>
      <Helmet>
        <title>
          Our Services - Mutual Funds, Insurance & Financial Planning |
          Wisdom Consultancy
        </title>

        <meta
          name="description"
          content="Professional financial solutions focused on wealth creation, protection, and long-term financial success."
        />
      </Helmet>

      {/* MAIN SECTION */}
      <section className="relative overflow-hidden bg-[#f6f7f8]">
        {/* GRID BACKGROUND */}
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: `
              linear-gradient(to right, #d8d8d8 1px, transparent 1px),
              linear-gradient(to bottom, #d8d8d8 1px, transparent 1px)
            `,
            backgroundSize: '40px 40px',
          }}
        />

        <div className="container-custom relative z-10 py-20">
          {/* HERO */}
          <div className="grid lg:grid-cols-2 gap-14 items-start">
            {/* LEFT CONTENT */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              {/* BADGE */}
              <div className="inline-flex items-center gap-3 bg-white shadow-md px-5 py-3 rounded-full mb-8">
                <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
                  <FaChartLine />
                </div>

                <span className="font-semibold text-[#0b1c39]">
                  Financial Services
                </span>
              </div>

              {/* HEADING */}
              <h1 className="text-5xl md:text-7xl font-extrabold leading-tight text-[#222]">
                Financial Planning
                <br />
                That Works{' '}
                <span className="text-[#67bf73]">for You</span>
              </h1>

              {/* SUB HEADING */}
              <h3 className="text-2xl md:text-3xl font-bold text-[#2e56b8] mt-6">
                Secure. Grow. Prosper.
              </h3>

              {/* DESCRIPTION */}
              <p className="mt-6 text-lg md:text-xl text-gray-600 leading-9 max-w-2xl">
                Professional financial solutions focused on wealth creation,
                protection, and long-term financial success.
              </p>

              <p className="mt-4 text-lg md:text-xl text-gray-600 leading-9 max-w-2xl font-semibold">
                Yagneshkumar Rajeshbhai Dole is an AMFI Registered Mutual Fund Distributor bearing ARN 185896.
              </p>

              {/* BUTTON */}
              <div className="mt-10">
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
                >
                  Book Free Consultation
                  <FaArrowRight />
                </Link>
              </div>
            </motion.div>

            {/* RIGHT IMAGE - Updated with proper spacing and visible content */}
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="relative"
            >
              {/* MAIN IMAGE */}
              <div className="rounded-[35px] overflow-hidden shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=1200&auto=format&fit=crop"
                  alt="Financial Planning"
                  className="w-full h-[450px] object-cover"
                />
              </div>

              {/* FLOATING CARD - Wealth Growth - Repositioned for visibility */}
              <div className="absolute -bottom-8 -left-6 bg-gradient-to-br from-[#1f4ba8] to-[#255bcb] text-white rounded-[28px] p-6 w-[280px] shadow-2xl z-20">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-2xl bg-white/20 flex items-center justify-center">
                    <FaWallet size={20} />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold">Wealth Growth</h3>
                    <p className="text-xs opacity-80">Smart Financial Planning</p>
                  </div>
                </div>

                {/* Graph Chart */}
                <div className="mt-4">
                  <svg viewBox="0 0 280 80" className="w-full" fill="none">
                    <path
                      d="M0 70 C30 65, 50 20, 80 35 S130 60, 170 30 S220 50, 280 25"
                      stroke="rgba(255,255,255,0.6)"
                      strokeWidth="2.5"
                      fill="none"
                      strokeLinecap="round"
                    />
                    <path
                      d="M0 70 C30 65, 50 20, 80 35 S130 60, 170 30 S220 50, 280 25"
                      stroke="rgba(255,255,255,0.2)"
                      strokeWidth="6"
                      fill="none"
                      strokeLinecap="round"
                    />
                    {/* Data points */}
                    <circle cx="50" cy="22" r="3" fill="#67bf73" />
                    <circle cx="170" cy="32" r="3" fill="#67bf73" />
                    <circle cx="280" cy="27" r="4" fill="#67bf73" stroke="white" strokeWidth="1.5" />
                  </svg>
                  
                  {/* Stats */}
                  <div className="flex justify-between mt-3 pt-2 border-t border-white/20">
                    <div>
                      <p className="text-[10px] opacity-70">Year 1</p>
                      <p className="text-xs font-bold">₹50K</p>
                    </div>
                    <div>
                      <p className="text-[10px] opacity-70">Year 5</p>
                      <p className="text-xs font-bold">₹5L</p>
                    </div>
                    <div>
                      <p className="text-[10px] opacity-70">Year 10</p>
                      <p className="text-xs font-bold">₹25L</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Secure Future Card - Top Right */}
              <div className="absolute -top-6 -right-4 bg-white rounded-2xl shadow-xl p-4 w-[180px] z-20">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
                    <FaShieldAlt size={14} />
                  </div>
                  <h4 className="font-bold text-[#0b1c39] text-sm">Secure Future</h4>
                </div>
                <p className="text-[10px] text-gray-500 leading-4">
                  Smart Financial Planning with guaranteed returns
                </p>
                <div className="mt-2 flex items-center gap-1 text-[#67bf73] text-[10px] font-semibold">
                  <span>✓ Tax Saving</span>
                  <span className="w-1 h-1 rounded-full bg-gray-300"></span>
                  <span>✓ Wealth Growth</span>
                </div>
              </div>

              {/* Stats Card - Bottom Right */}
              <div className="absolute -bottom-4 right-4 bg-white rounded-2xl shadow-xl p-3 w-[160px] z-20">
                <div className="flex items-center gap-2">
                  <FaUsers className="text-[#2e56b8] text-sm" />
                  <div>
                    <p className="text-lg font-bold text-[#222]">1200+</p>
                    <p className="text-[9px] text-gray-500">Active Clients</p>
                  </div>
                </div>
                <div className="flex items-center gap-2 mt-2 pt-2 border-t border-gray-100">
                  <FaBullseye className="text-[#67bf73] text-sm" />
                  <div>
                    <p className="text-xs font-semibold text-[#222]">₹50Cr+</p>
                    <p className="text-[9px] text-gray-500">Wealth Managed</p>
                  </div>
                </div>
              </div>

              {/* Circle Decoration - Background */}
              <div className="absolute top-1/3 -left-8 w-24 h-24 rounded-full bg-[#67bf73]/10 -z-10"></div>
              <div className="absolute bottom-1/4 -right-8 w-32 h-32 rounded-full bg-[#2e56b8]/10 -z-10"></div>
            </motion.div>
          </div>

          {/* CATEGORY FILTER */}
          <div className="mt-24 flex flex-wrap justify-center gap-4">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 border ${
                  selectedCategory === cat.id
                    ? 'bg-[#2e56b8] text-white border-[#2e56b8] shadow-lg'
                    : 'bg-white text-[#0b1c39] border-gray-200 hover:shadow-md'
                }`}
              >
                <span className="mr-2">{cat.icon}</span>
                {cat.name}
              </button>
            ))}
          </div>

          {/* TITLE */}
          <div className="mt-24 mb-14 text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-[#222]">
              Professional{' '}
              <span className="text-[#2e56b8]">
                Services
              </span>{' '}
              & Financial Solutions
            </h2>

            <p className="mt-5 text-lg text-gray-600 max-w-3xl mx-auto">
              Customized financial strategies focused on growth,
              protection, and future financial confidence.
            </p>
          </div>

          {/* SERVICES GRID */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredServices.map((service, index) => (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
                className="group bg-white rounded-[30px] p-8 shadow-md hover:shadow-2xl transition-all duration-300 border border-transparent hover:border-[#dbe7ff]"
              >
                {/* ICON */}
                <div className="w-20 h-20 rounded-3xl bg-[#edf3ff] flex items-center justify-center text-4xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  {service.title === 'Mutual Funds' && (
                    <FaChartLine className="text-[#2e56b8] text-2xl" />
                  )}

                  {service.title === 'Health Insurance' && (
                    <FaHeartbeat className="text-[#67bf73] text-2xl" />
                  )}

                  {service.title === 'Life Insurance' && (
                    <FaShieldAlt className="text-[#2e56b8] text-2xl" />
                  )}

                  {service.title === 'Home Loans' && (
                    <FaHome className="text-[#67bf73] text-2xl" />
                  )}

                  {service.title === 'Car & Bike Insurance' && (
                    <FaCar className="text-[#2e56b8] text-2xl" />
                  )}
                </div>

                {/* TITLE */}
                <h3 className="text-2xl font-bold text-[#0b1c39] mb-4">
                  {service.title}
                </h3>

                {/* DESCRIPTION */}
                <p className="text-gray-600 leading-8 mb-6">
                  {service.description}
                </p>

                {/* FEATURES */}
                {service.features && service.features.length > 0 && (
                  <div className="space-y-3 mb-8">
                    {service.features.slice(0, 6).map((feature, i) => (
                      <div
                        key={i}
                        className="flex items-start gap-3 text-gray-700 text-sm"
                      >
                        <div className="w-2 h-2 rounded-full bg-[#67bf73] mt-2 flex-shrink-0" />
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* BUTTON */}
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 text-[#2e56b8] font-semibold hover:gap-4 transition-all duration-300"
                >
                  Enquire Now
                  <FaArrowRight />
                </Link>
              </motion.div>
            ))}
          </div>

          {/* EMPTY */}
          {filteredServices.length === 0 && (
            <div className="text-center py-20">
              <p className="text-gray-500 text-lg">
                No services found in this category.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="py-20 relative overflow-hidden bg-[#eef6f0]">
        {/* GRID */}
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: `
              linear-gradient(to right, #d8d8d8 1px, transparent 1px),
              linear-gradient(to bottom, #d8d8d8 1px, transparent 1px)
            `,
            backgroundSize: '40px 40px',
          }}
        />

        <div className="container-custom relative z-10">
          <div className="bg-white rounded-[40px] shadow-2xl p-10 md:p-16 text-center border border-[#e7f0eb]">
            {/* BADGE */}
            <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-8">
              <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
                <FaChartLine />
              </div>

              <span className="font-semibold text-[#0b1c39]">
                Financial Consultation
              </span>
            </div>

            {/* TITLE */}
            <h2 className="text-4xl md:text-5xl font-bold text-[#222] leading-tight mb-6">
              Need Expert{' '}
              <span className="text-[#67bf73]">
                Financial Guidance?
              </span>
            </h2>

            {/* DESCRIPTION */}
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-9 mb-10">
              Our financial experts are ready to guide you with secure,
              tailored wealth management and investment solutions.
            </p>

            {/* BUTTON */}
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
            >
              Schedule Free Consultation
              <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;